module.exports = __webpack_public_path__ + "img/cover.0c4b5549.png";